import React from "react";
import aboutUs2 from "../../../../assets/about_us_2.png";
import aboutUs2Mobile from "../../../../assets/about_us_2_mobile.png";
import ourMission from "../../../../assets/our_mission.png";
import ourVision from "../../../../assets/our_vision.png";
import { Heart, TrendingUp } from "lucide-react";

const cardStyle = {
  backgroundColor: "rgba(26,26,26,0.6)",
  borderRadius: "32px",
  border: "1px solid rgba(255,255,255,0.05)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
};

const eightBoxes = [
  { label: "ai ordering",      icon: "ai_ordering_icon.png" },
  { label: "business profile", icon: "business_profile_icon.png" },
  { label: "engagement",       icon: "engagement_work_icon.png" },
  { label: "payments",         icon: "payments_icon.png" },
  { label: "loyalty",          icon: "loyalty_icon.png" },
  { label: "analytics",        icon: "analytics_icon_2.png" },
  { label: "qr experiences",   icon: "qr_ordering_icon.png" },
  { label: "insights",         icon: "insights_icon.png" },
];

const AboutUsNavContent = () => {
  return (
    <div className="w-full text-white" style={{ backgroundColor: "#020013" }}>

      {/* ── Description ── */}
      <section className="w-full px-4 md:px-16 lg:px-20 py-16 md:py-20">
        <p
          className="lowercase text-center mx-auto"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(16px,2vw,22px)", lineHeight: "1.75", letterSpacing: "0.005em", color: "#FFFFFF", maxWidth: "100%" }}
        >
          beɘmz is a real-time, restaurant and retail digital market place built to improve customer
          experience and grow your business by bringing essential services right to your fingertips.
          from orders to payments, social media marketing and rides we connect you instantly to who
          matters most — your customer. our platform ensures speed, convenience and trust — all in
          one seamless experience.
        </p>
      </section>

      {/* ── Mission + Vision ── */}
      <section className="w-full px-4 md:px-16 lg:px-20 pb-16 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Our Mission */}
          <div className="flex flex-col gap-5 p-8 md:p-10" style={cardStyle}>
            <img src={ourMission} alt="our mission" className="w-16 h-16 object-contain" />
            <h3
              className="lowercase"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "32px", lineHeight: "1.1", color: "#FFFFFF" }}
            >
              our mission
            </h3>
            <p
              className="lowercase"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "18px", lineHeight: "1.7", color: "#FFFFFF" }}
            >
              to empower every local business with intelligent technology that transforms every
              transaction into a meaningful, lasting relationship.
            </p>
          </div>

          {/* Our Vision */}
          <div className="flex flex-col gap-5 p-8 md:p-10" style={cardStyle}>
            <img src={ourVision} alt="our vision" className="w-16 h-16 object-contain" />
            <h3
              className="lowercase"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "32px", lineHeight: "1.1", color: "#FFFFFF" }}
            >
              our vision
            </h3>
            <p
              className="lowercase"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "18px", lineHeight: "1.7", color: "#FFFFFF" }}
            >
              to become the world's most connected customer experience platform, where technology
              disappears and only the connection remains.
            </p>
          </div>
        </div>
      </section>

      {/* ── Mobile mockup image — overlaps down into Our Value section ── */}
      <section className="relative z-20 w-full px-4 md:px-16 lg:px-20 pb-0">
        <img src={aboutUs2Mobile} alt="beɘmz app" className="block md:hidden w-full rounded-[24px] object-cover" />
        <img src={aboutUs2} alt="beɘmz app" className="hidden md:block w-full rounded-[34px] object-cover" />
      </section>

      {/* ── Our Value — pulled up behind the image ── */}
      <section
        className="relative z-10 w-full flex flex-col items-center text-center -mt-[40px] md:-mt-[40px] pt-[60px] md:pt-[118px]"
        style={{ backgroundColor: "#15121D", paddingBottom: "112px", paddingLeft: "clamp(16px, 6vw, 86px)", paddingRight: "clamp(16px, 5.5vw, 80px)", gap: "10px" }}
      >
        <h2
          className="lowercase mb-6"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "40px", lineHeight: "48px", letterSpacing: "-0.8px" }}
        >
          <span style={{ color: "#E7DFF0" }}>our </span>
          <span style={{ color: "#9747FF" }}>value</span>
        </h2>
        <p
          className="lowercase mx-auto"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "20px", lineHeight: "160%", letterSpacing: "-0.8px", color: "#FFFFFF", maxWidth: "860px" }}
        >
          beɘmz delivers innovative high-tech solutions at an affordable cost to all within the
          restaurant and retail business space. grow your operations with ease and deepen your
          customer connections giving everyone a vip experience, always. while our no commission
          promise and low fixed fees ensures your revenue remains yours and your profits stay in
          your pocket.
        </p>
      </section>

      {/* ── More than software ── */}
      <section
        className="w-full flex flex-col"
        style={{ paddingTop: "120px", paddingBottom: "120px", paddingLeft: "clamp(16px, 5.5vw, 80px)", paddingRight: "clamp(16px, 5.5vw, 80px)", gap: "59px" }}
      >
        {/* Heading row */}
        <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-6">
          <h2
            className="lowercase"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "40px", lineHeight: "48px", letterSpacing: "-0.8px" }}
          >
            <span style={{ color: "#FFFFFF" }}>more than software.<br />a </span>
            <span style={{ color: "#9747FF" }}>connected ecosystem.</span>
          </h2>
          <p
            className="lowercase md:max-w-[420px] md:text-left"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "18px", lineHeight: "1.6", color: "#FFFFFF" }}
          >
            we've unified the most critical parts of your business into one high-performance machine.
          </p>
        </div>

        {/* 8-box grid — 2 rows × 4 cols, row-gap 32px, col-gap 17px */}
        <div
          className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-x-[17px] md:gap-y-8"
        >
          {eightBoxes.map(({ label, icon }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center text-center lowercase p-5 md:p-10"
              style={{ ...cardStyle, borderRadius: "32px", gap: "24px" }}
            >
              {icon ? (
                <img src={require(`../../../../assets/${icon}`)} alt={label} className="w-6 h-6 md:w-8 md:h-8 object-contain" />
              ) : label === "loyalty" ? (
                <Heart className="w-6 h-6 md:w-8 md:h-8" style={{ color: "#9747FF" }} />
              ) : (
                <TrendingUp className="w-6 h-6 md:w-8 md:h-8" style={{ color: "#9747FF" }} />
              )}
              <span
                style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "clamp(13px, 3.5vw, 20px)", lineHeight: "1.4", letterSpacing: "0px", color: "#E7DFF0", textAlign: "center" }}
              >
                {label}
              </span>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default AboutUsNavContent;
